export default "__VITE_ASSET__76791c32__"